var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.contextMenu,style:({ left: _vm.mouseX + 'px', top: _vm.mouseY + 'px' })},_vm._l((_vm.pages),function(page){return _c('router-link',{key:page.name,class:_vm.$style.link,attrs:{"to":{
      name: page.name,
      query: {
        dateFrom: _vm.eventRange.day.from,
        dateTo: _vm.eventRange.day.to,
        isWorktimeOnly: _vm.isWorktimeOnly,
        state: 2,
        selectedComputerId: _vm.userId,
        email: _vm.email,
      },
    },"target":"_blank"},nativeOn:{"click":function($event){return _vm.$emit('go')}}},[_vm._v(" "+_vm._s(page.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }